import React, {useState} from "react";
import "../legalNotice/LegalNotice.scss";

const CONSENT_KEY = "analyticsConsent";

function clearAnalyticsCookies() {
  document.cookie.split(";").forEach(cookie => {
    const name = cookie.split("=")[0].trim();
    if (name === "_ga" || name.startsWith("_ga_")) {
      document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
      document.cookie = `${name}=; Max-Age=0; path=/; domain=.${window.location.hostname}; SameSite=Lax`;
    }
  });
}

export default function Privacy() {
  const [consent, setConsent] = useState(() => {
    try {
      return window.localStorage.getItem(CONSENT_KEY);
    } catch (error) {
      return null;
    }
  });

  function updateConsent(value) {
    try {
      window.localStorage.setItem(CONSENT_KEY, value);
    } catch (error) {
      // Le choix reste pris en compte pour la page en cours.
    }

    if (value === "refused") clearAnalyticsCookies();
    setConsent(value);
    window.location.reload();
  }

  return (
    <main id="main-content" className="legal-notice" tabIndex="-1">
      <a className="legal-notice__back" href="#/">
        ← Retour à l’accueil
      </a>

      <article>
        <h1>Politique de confidentialité et cookies</h1>
        <p className="legal-notice__updated">
          Dernière mise à jour : 2 août 2026
        </p>

        <section>
          <h2>Responsable du traitement</h2>
          <p>
            KV2, micro-entreprise représentée par Stéphane Simon, est
            responsable des traitements de données réalisés sur le site{" "}
            <strong>simon.wf</strong>.
          </p>
          <p>
            Adresse : 17 rue des Petits Bus, 60590 Flavacourt, France
            <br />
            SIRET : 530 476 183 00013
          </p>
        </section>

        <section>
          <h2>Données traitées</h2>
          <p>
            Ce site ne comporte pas de formulaire et ne collecte pas directement
            de données d’identité. Si vous acceptez la mesure d’audience, des
            informations techniques et de navigation peuvent être traitées :
            pages consultées, durée de consultation, type d’appareil, navigateur
            et zone géographique approximative. L’adresse IP est anonymisée dans
            la configuration Analytics du site.
          </p>
        </section>

        <section>
          <h2>Finalité et base légale</h2>
          <p>
            Google Analytics 4 est utilisé pour mesurer l’audience et améliorer
            le contenu du site. Ce traitement repose exclusivement sur votre
            consentement. Aucun script Analytics n’est chargé avant votre
            accord.
          </p>
        </section>

        <section>
          <h2>Cookies et conservation</h2>
          <p>
            Après acceptation, Google Analytics peut déposer les cookies
            <code> _ga</code> et <code>_ga_*</code>. Leur durée de vie est
            limitée à 13 mois. Le choix d’accepter ou de refuser est enregistré
            localement dans votre navigateur sous la clé{" "}
            <code>analyticsConsent</code>.
          </p>
        </section>

        <section>
          <h2>Destinataires et transferts</h2>
          <p>
            Les données de mesure d’audience sont accessibles à KV2 et traitées
            par Google en qualité de fournisseur de Google Analytics. Leur
            traitement peut impliquer un transfert hors de l’Union européenne,
            encadré par les mécanismes de protection applicables proposés par
            Google.
          </p>
        </section>

        <section>
          <h2>Vos droits</h2>
          <p>
            Vous pouvez demander l’accès, la rectification, l’effacement ou la
            limitation de vos données, vous opposer à un traitement et retirer
            votre consentement à tout moment. Vous pouvez également introduire
            une réclamation auprès de la CNIL.
          </p>
          <p>
            Pour exercer vos droits, utilisez le{" "}
            <a
              href="https://kv2.fr/contact-postmaster/"
              target="_blank"
              rel="noopener noreferrer"
            >
              formulaire de contact KV2
            </a>
            .
          </p>
        </section>

        <section>
          <h2>Gérer votre consentement</h2>
          <p>
            Choix actuel :{" "}
            <strong>
              {consent === "accepted"
                ? "mesure d’audience acceptée"
                : consent === "refused"
                ? "mesure d’audience refusée"
                : "aucun choix enregistré"}
            </strong>
          </p>
          <div className="privacy-actions">
            <button type="button" onClick={() => updateConsent("refused")}>
              Refuser ou retirer mon consentement
            </button>
            <button type="button" onClick={() => updateConsent("accepted")}>
              Accepter la mesure d’audience
            </button>
          </div>
        </section>
      </article>
    </main>
  );
}
